import {Component, Input, OnInit} from '@angular/core';
import {AmountStatus, Competitor, EventItem, Lookups, Race, RaceRegistration, RegistrationStatus} from "@model";
import {AbstractComponent} from "@components";
import {MY_ORDER_COMPLETE_PAYMENT, MY_TRACEY_ORDERS} from "../../../../../app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";
import {ExportService} from "@services";

@Component({
  selector: 'app-my-tracey-order-details',
  templateUrl: './my-tracey-order-details.component.html',
  styleUrl: './my-tracey-order-details.component.scss',
  standalone: false
})
export class MyTraceyOrderDetailsComponent extends AbstractComponent implements OnInit {
  @Input() languages: Lookups[] = [];
  @Input() registration: RaceRegistration | undefined;

  event: EventItem | undefined;
  race: Race | undefined;
  competitors: Competitor[] = [];
  amountStatus: AmountStatus = AmountStatus.NOT_PAID;
  showOrderItemsSection: boolean = false;
  isPayable: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private exportService: ExportService) {
    super();
  }

  ngOnInit(): void {
    this.event = this.registration?.events;
    this.race = this.registration?.race;
    this.competitors = this.registration?.competitors ?? [];
    this.amountStatus = RaceRegistration.getAmountStatus(this.registration);

    this.showOrderItemsSection =
        this.competitors.length > 0 &&
        this.competitors.some(
            c =>
                c.raceCommercialItem ||
                (c.raceAdditionalPricingItems?.length ?? 0) > 0
        );
    this.isPayable = this.registration?.registrationStatus === RegistrationStatus.RESERVED_FOR_PAYMENT &&
        (!!this.registration?.wsPayFormUrl || !!this.registration?.bankTransferInfo);
  }


  downloadInvoice(){
    if (this.registration?.order?.id) {
      this.exportService.downloadInvoice(this.registration.order.id)
    }
  }

  downloadReceipt() {

  }

  goToCompletePayment() {
    this.router.navigate([MY_ORDER_COMPLETE_PAYMENT], {
      relativeTo: this.route,
      queryParamsHandling: "preserve"
    });
  }

  goBack() {
    this.router.navigate([MY_TRACEY_ORDERS]);
  }


  protected readonly AmountStatus = AmountStatus;
}
